export const orderTypes = [
    { title: "Всі", value: "" },
    { title: "Террмінал", value: "terminal" },
    { title: "Карта", value: "card" },
    { title: "Кредит", value: "credit" },
];
